import { AssetDimensionTableRow } from "./type";
import { DimensionScoreList } from "../StructuredCards/common/DimensionScoreList";
import { cn } from "utils";

export interface AssetDimensionScoreTableProps {
  rows: AssetDimensionTableRow[];
  sectionLabel?: string;
  className?: string;
}

/**
 *  单资产多维度评分表，展示每个维度的分数和排名。 Figma：81148:35915。
 * @param param0
 * @returns
 */
export const AssetDimensionScoreTable: React.FC<
  AssetDimensionScoreTableProps
> = ({ rows, sectionLabel, className }) => {
  const dimensions = rows.map((row) => ({
    label: row.dimensionName,
    score: row.scoreValue,
    rankLabel: `${row.rankValue}/${row.rankTotalAssets}`,
  }));
  return (
    <div className={cn("flex flex-col gap-2", className)}>
      <p className="body_medium_m text-content_primary">{sectionLabel}</p>
      <DimensionScoreList
        items={dimensions}
        rankStyle={"brand"}
        highlightFirst={true}
      />
    </div>
  );
};
